(function () {
  var staticHeaderScript =
    document.currentScript ||
    document.querySelector("script[data-tmg-static-header-script]");
  var staticHeaderStickyEnabled =
    staticHeaderScript &&
    staticHeaderScript.getAttribute("data-sticky-enabled") === "true";
  var staticHeaderReadyEvent = "tmg:static-header-ready";
  var staticHeaderReadyCallbacks = [];
  var staticHeaderReadyDispatched = false;

  function onStaticHeaderReady(callback) {
    staticHeaderReadyCallbacks.push(callback);

    if (staticHeaderScript && typeof staticHeaderScript.addEventListener === "function") {
      staticHeaderScript.addEventListener(staticHeaderReadyEvent, callback);
    }
  }

  if (staticHeaderScript && typeof staticHeaderScript.addEventListener === "function") {
    staticHeaderScript.addEventListener(staticHeaderReadyEvent, function () {
      staticHeaderReadyDispatched = true;
    });
  }

onStaticHeaderReady(function () {
  if (window.__tmgFinalMobileDropdownController) return;
  window.__tmgFinalMobileDropdownController = true;

  var mq = window.matchMedia("(max-width: 990px)");
  var pop = document.getElementById("tmgMobileDD");
  var activeTrigger = null;

  if (!pop) return;
  if (pop.parentElement !== document.body) document.body.appendChild(pop);

  pop.classList.add("tmg-shared-mobile-dd");

  function isMobile() {
    return mq.matches;
  }

  function closeSharedDropdown() {
    activeTrigger = null;
    pop.className = "tmg-mobile-dd tmg-shared-mobile-dd";
    pop.setAttribute("aria-hidden", "true");
    pop.innerHTML = "";
    pop.style.left = "";
    pop.style.top = "";
    document.body.classList.remove(
      "tmg-mobile-active-dropdown--ic",
      "tmg-mobile-active-dropdown--tmg",
      "tmg-mobile-greenhouses-open"
    );
  }

  function positionSharedDropdown(trigger) {
    var rect = trigger.getBoundingClientRect();
    var padding = 10;
    var gap = -6;

    pop.style.left = "0px";
    pop.style.top = "0px";

    var width = pop.offsetWidth || 260;
    var height = pop.offsetHeight || 260;
    var left = rect.left;
    var top = rect.bottom + gap;

    if (left < padding) left = padding;
    if (left + width > window.innerWidth - padding) left = window.innerWidth - width - padding;
    if (top + height > window.innerHeight - padding) top = rect.top - height - gap;
    if (top < padding) top = padding;

    pop.style.left = Math.round(left) + "px";
    pop.style.top = Math.round(top) + "px";
  }

  function escapeHtml(text) {
    return String(text || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function openSharedDropdown(trigger, html, type, extraClass) {
    var sameOpen = pop.classList.contains("is-open") && activeTrigger === trigger;

    closeSharedDropdown();

    if (sameOpen) return;

    activeTrigger = trigger;
    pop.innerHTML = html;
    pop.classList.add("is-open");
    if (extraClass) pop.classList.add(extraClass);
    pop.setAttribute("aria-hidden", "false");

    document.body.classList.add(type === "ic" ? "tmg-mobile-active-dropdown--ic" : "tmg-mobile-active-dropdown--tmg");
    if (extraClass === "is-greenhouses-dropdown") document.body.classList.add("tmg-mobile-greenhouses-open");

    positionSharedDropdown(trigger);
  }

  function buildFlatLinks(panel) {
    var html = "";

    panel.querySelectorAll("a").forEach(function (link) {
      var text = (link.textContent || "").trim();
      if (!text) return;

      html += '<a href="' + (link.getAttribute("href") || "#") + '">' + escapeHtml(text) + "</a>";
    });

    return html;
  }

  document.addEventListener("click", function (event) {
    if (!isMobile()) return;

    var icTrigger = event.target.closest(".ic-nav-link");
    var tmgTrigger = event.target.closest(".tmg-nav-item--dropdown[data-dd] [data-dd-toggle]");
    var greenhouseFloatTrigger = event.target.closest(".tmg-nav-item--greenhouses.tmg-nav-item--float .tmg-nav-link");

    if (icTrigger) {
      var icItem = icTrigger.closest(".ic-nav-item");
      var icPanel = icItem ? icItem.querySelector(".ic-dropdown") : null;
      if (!icPanel) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openSharedDropdown(icTrigger, icPanel.innerHTML, "ic", "is-ic-dropdown");
      return;
    }

    if (tmgTrigger) {
      var tmgItem = tmgTrigger.closest(".tmg-nav-item--dropdown[data-dd]");
      var tmgPanel = tmgItem ? tmgItem.querySelector("[data-dd-panel]") : null;
      if (!tmgPanel) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openSharedDropdown(
        tmgTrigger,
        tmgItem.classList.contains("tmg-nav-item--greenhouses") ? tmgPanel.innerHTML : buildFlatLinks(tmgPanel),
        "tmg",
        tmgItem.classList.contains("tmg-nav-item--greenhouses") ? "is-greenhouses-dropdown" : ""
      );
      return;
    }

    if (greenhouseFloatTrigger) {
      var greenhouseFloatItem = greenhouseFloatTrigger.closest(".tmg-nav-item--greenhouses.tmg-nav-item--float");
      var greenhouseFloatPanel = greenhouseFloatItem ? greenhouseFloatItem.querySelector(".tmg-dropdown") : null;
      if (!greenhouseFloatPanel) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openSharedDropdown(
        greenhouseFloatTrigger,
        greenhouseFloatPanel.innerHTML,
        "tmg",
        "is-greenhouses-dropdown"
      );
      return;
    }

    if (!event.target.closest("#tmgMobileDD")) closeSharedDropdown();
  }, true);

  pop.addEventListener("click", function (event) {
    var trigger = event.target.closest(".ic-click-trigger");
    if (!trigger || (!pop.classList.contains("is-ic-dropdown") && !pop.classList.contains("is-greenhouses-dropdown"))) return;

    var group = trigger.closest(".ic-click-group");
    if (!group) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    Array.prototype.forEach.call(group.parentElement.children, function (sibling) {
      if (sibling !== group && sibling.classList && sibling.classList.contains("ic-click-group")) {
        sibling.classList.remove("is-open");
      }
    });

    group.classList.toggle("is-open");
    positionSharedDropdown(activeTrigger || trigger);
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeSharedDropdown();
  });

  window.addEventListener("resize", closeSharedDropdown, { passive: true });
  window.addEventListener("scroll", closeSharedDropdown, { passive: true });
});

onStaticHeaderReady(function () {
  if (window.__tmgOutsideDropdownCloseBound) return;
  window.__tmgOutsideDropdownCloseBound = true;

  function clickedInsideHeaderDropdown(event) {
    return !!event.target.closest(
      ".tmg-nav-item--dropdown, " +
      ".tmg-nav-item--float, " +
      ".ic-nav-item, " +
      ".ic-floating-dropdown, " +
      "#tmgMobileDD, " +
      "#tmgFloatDropdown, " +
      ".tmg-country, " +
      ".m-country, " +
      ".tmg-sticky-categories"
    );
  }

  function closeHeaderDropdowns() {
    var floatDropdown = document.getElementById("tmgFloatDropdown");
    var mobileDropdown = document.getElementById("tmgMobileDD");

    if (floatDropdown) {
      floatDropdown.classList.remove("is-open", "is-greenhouses-dropdown");
      floatDropdown.setAttribute("aria-hidden", "true");
      floatDropdown.innerHTML = "";
    }

    if (mobileDropdown) {
      mobileDropdown.classList.remove("is-open", "is-greenhouses-dropdown");
      mobileDropdown.setAttribute("aria-hidden", "true");
      mobileDropdown.innerHTML = "";
    }

    document.querySelectorAll(".ic-floating-dropdown").forEach(function (dropdown) {
      dropdown.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
      dropdown.innerHTML = "";
    });

    document.querySelectorAll(".ic-click-group.is-open").forEach(function (group) {
      group.classList.remove("is-open");
    });

    document.querySelectorAll(".tmg-nav-item--dropdown.is-open, .tmg-nav-item--float.is-open, .tmg-sticky-categories.is-open").forEach(function (item) {
      item.classList.remove("is-open", "active");
    });

    document.querySelectorAll(".tmg-country.is-open, .m-country.is-open").forEach(function (country) {
      country.classList.remove("is-open");

      country.querySelectorAll("[aria-expanded]").forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      });

      country.querySelectorAll(".tmg-country__dropdown, .m-country__dropdown").forEach(function (dropdown) {
        dropdown.hidden = true;
      });
    });

    document.body.classList.remove(
      "tmg-mobile-active-dropdown--ic",
      "tmg-mobile-active-dropdown--tmg",
      "tmg-mobile-greenhouses-open"
    );
  }

  document.addEventListener("click", function (event) {
    if (clickedInsideHeaderDropdown(event)) return;
    closeHeaderDropdowns();
  });

  document.addEventListener("touchstart", function (event) {
    if (clickedInsideHeaderDropdown(event)) return;
    closeHeaderDropdowns();
  }, { passive: true });
});

onStaticHeaderReady(function () {
  function setUtilityHeight() {
    var utility = document.querySelector(".tmg-utility");
    var height = utility ? utility.offsetHeight : 24;
    document.documentElement.style.setProperty("--tmg-utility-h", height + "px");
  }

  setUtilityHeight();
  window.addEventListener("resize", setUtilityHeight);
  window.addEventListener("load", setUtilityHeight);
});

onStaticHeaderReady(function () {
  document.querySelectorAll(".mega-left-item").forEach(function (item) {
    item.addEventListener("mouseover", function () {
      var category = item.dataset.category;

      document.querySelectorAll(".mega-left-item").forEach(function (button) {
        button.classList.remove("active");
      });

      item.classList.add("active");

      document.querySelectorAll(".mega-category").forEach(function (panel) {
        panel.classList.toggle("active", panel.dataset.category === category);
      });
    });
  });
});

onStaticHeaderReady(function () {
  var host = window.location.hostname || "";
  var currentDomain = "ca";

  if (host.endsWith(".com.au")) currentDomain = "com.au";
  else if (host.endsWith(".com")) currentDomain = "com";
  else if (host.endsWith(".ca")) currentDomain = "ca";

  document.querySelectorAll(".country-flag-current").forEach(function (flagWrapper) {
    flagWrapper.querySelectorAll("img[data-domain]").forEach(function (img) {
      img.style.display = img.getAttribute("data-domain") === currentDomain ? "inline-block" : "none";
    });
  });
});

onStaticHeaderReady(function () {
  function bindDropdown(rootSelector, triggerSelector, dropdownSelector) {
    var root = document.querySelector(rootSelector);
    if (!root) return;

    var trigger = root.querySelector(triggerSelector);
    var dropdown = root.querySelector(dropdownSelector);
    if (!trigger || !dropdown) return;

    function open() {
      dropdown.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      root.classList.add("is-open");
    }

    function close() {
      dropdown.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      root.classList.remove("is-open");
    }

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropdown.hidden ? open() : close();
    });

    document.addEventListener("click", function (event) {
      if (!root.contains(event.target)) close();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") close();
    });

    window.addEventListener("scroll", close, { passive: true });
  }

  bindDropdown(".tmg-country", ".tmg-country__caret", "#tmg-country-dropdown");
  bindDropdown(".m-country", ".m-country__trigger", "#m-country-dropdown");
});

onStaticHeaderReady(function () {
  var float = document.getElementById("tmgFloatDropdown");
  if (!float) return;

  var activeAnchor = null;
  var closeTimer = null;

  function isDesktop() {
    return window.matchMedia("(min-width: 991px)").matches;
  }

  function closeFloat() {
    activeAnchor = null;
    float.classList.remove("is-open", "is-greenhouses-dropdown");
    float.setAttribute("aria-hidden", "true");
    float.innerHTML = "";
  }

  function positionFloat(anchor) {
    var rect = anchor.getBoundingClientRect();
    var padding = float.classList.contains("is-greenhouses-dropdown") ? 28 : 10;
    var gap = -5;

    float.style.top = "0px";
    float.style.left = "0px";

    var width = float.offsetWidth || 240;
    var height = float.offsetHeight || 200;

    var left = rect.left;
    var top = rect.bottom + gap;

    if (left + width > window.innerWidth - padding) left = Math.max(padding, window.innerWidth - width - padding);
    if (top + height > window.innerHeight - padding) top = Math.max(padding, rect.top - height - gap);

    float.style.left = Math.round(left) + "px";
    float.style.top = Math.round(top) + "px";
  }

  function openFloatFromItem(item) {
    if (!isDesktop()) return;

    var anchor = item.querySelector(".tmg-nav-link");
    var dropdown = item.querySelector(".tmg-dropdown");
    if (!anchor || !dropdown) return;

    var html = "";
    if (item.classList.contains("tmg-nav-item--greenhouses")) {
      html = dropdown.innerHTML;
    } else {
      var links = dropdown.querySelectorAll("a");
      if (!links.length) return;

      links.forEach(function (link) {
        var href = link.getAttribute("href") || "#";
        var text = (link.textContent || "").trim();
        if (text) html += '<a href="' + href + '">' + text.replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</a>";
      });
    }

    activeAnchor = anchor;
    float.innerHTML = html;
    float.setAttribute("aria-hidden", "false");
    float.classList.add("is-open");
    float.classList.toggle("is-greenhouses-dropdown", item.classList.contains("tmg-nav-item--greenhouses"));
    positionFloat(anchor);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeFloat, 140);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  document.querySelectorAll(".tmg-nav-item--float").forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      cancelClose();
      openFloatFromItem(item);
    });

    item.addEventListener("mouseleave", scheduleClose);
  });

  float.addEventListener("mouseenter", cancelClose);
  float.addEventListener("mouseleave", scheduleClose);

  document.addEventListener("scroll", function () {
    if (isDesktop()) closeFloat();
  }, { passive: true });

  window.addEventListener("resize", function () {
    if (activeAnchor && isDesktop()) positionFloat(activeAnchor);
  }, { passive: true });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeFloat();
  });
});

onStaticHeaderReady(function () {
  var activeItem = null;
  var closeTimer = null;

  function isMobile() {
    return window.matchMedia("(max-width: 990px)").matches;
  }

  function getDropdown() {
    var dropdown = document.querySelector(".ic-floating-dropdown");

    if (!dropdown) {
      dropdown = document.createElement("div");
      dropdown.className = "ic-floating-dropdown";
      dropdown.setAttribute("aria-hidden", "true");
      document.body.appendChild(dropdown);
    }

    return dropdown;
  }

  function closeDropdown() {
    var dropdown = document.querySelector(".ic-floating-dropdown");
    if (!dropdown) return;

    dropdown.classList.remove("is-open");
    dropdown.setAttribute("aria-hidden", "true");
    dropdown.innerHTML = "";
    activeItem = null;
  }

  function closeSharedMobileDropdown() {
    var pop = document.getElementById("tmgMobileDD");
    if (!pop) return;

    pop.classList.remove("is-open", "is-greenhouses-dropdown", "is-ic-dropdown");
    pop.setAttribute("aria-hidden", "true");
    pop.innerHTML = "";
    document.body.classList.remove("tmg-mobile-active-dropdown--ic");
    activeItem = null;
  }

  function positionSharedMobileDropdown(pop, anchor) {
    var rect = anchor.getBoundingClientRect();
    var padding = 10;
    var gap = -6;

    pop.style.left = "0px";
    pop.style.top = "0px";
    pop.style.removeProperty("display");
    pop.style.removeProperty("opacity");
    pop.style.removeProperty("visibility");
    pop.style.removeProperty("pointer-events");

    var width = pop.offsetWidth || 260;
    var height = pop.offsetHeight || 260;
    var left = rect.left;
    var top = rect.bottom + gap;

    if (left < padding) left = padding;
    if (left + width > window.innerWidth - padding) left = window.innerWidth - width - padding;
    if (top + height > window.innerHeight - padding) top = rect.top - height - gap;
    if (top < padding) top = padding;

    pop.style.left = Math.round(left) + "px";
    pop.style.top = Math.round(top) + "px";
  }

  function openSharedMobileDropdown(item) {
    var source = item.querySelector(".ic-dropdown");
    var link = item.querySelector(".ic-nav-link");
    var pop = document.getElementById("tmgMobileDD");
    if (!source || !link || !pop) return;

    if (pop.parentElement !== document.body) document.body.appendChild(pop);

    closeDropdown();

    pop.innerHTML = source.innerHTML;
    pop.classList.remove("is-greenhouses-dropdown");
    pop.classList.add("is-open", "is-ic-dropdown");
    pop.setAttribute("aria-hidden", "false");
    pop.style.setProperty("z-index", "2147483647", "important");

    document.body.classList.remove("tmg-mobile-active-dropdown--tmg", "tmg-mobile-greenhouses-open");
    document.body.classList.add("tmg-mobile-active-dropdown--ic");

    activeItem = item;
    positionSharedMobileDropdown(pop, link);
  }

  function positionDropdown(dropdown, anchor) {
    var rect = anchor.getBoundingClientRect();
    var padding = 10;
    var gap = -6;

    dropdown.style.left = "0px";
    dropdown.style.top = "0px";

    var width = dropdown.offsetWidth || 280;
    var height = dropdown.offsetHeight || 260;

    var left = rect.left;
    var top = rect.bottom + gap;

    if (left + width > window.innerWidth - padding) left = window.innerWidth - width - padding;
    if (left < padding) left = padding;

    if (top + height > window.innerHeight - padding) top = rect.top - height - gap;
    if (top < padding) top = padding;

    dropdown.style.left = Math.round(left) + "px";
    dropdown.style.top = Math.round(top) + "px";
  }

  function openDropdown(item) {
    var source = item.querySelector(".ic-dropdown");
    var link = item.querySelector(".ic-nav-link");
    if (!source || !link) return;

    var dropdown = getDropdown();
    dropdown.innerHTML = source.innerHTML;
    dropdown.classList.add("is-open");
    dropdown.setAttribute("aria-hidden", "false");

    activeItem = item;
    positionDropdown(dropdown, link);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeDropdown, 180);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  document.querySelectorAll(".ic-nav-item").forEach(function (item) {
    var link = item.querySelector(".ic-nav-link");
    var source = item.querySelector(".ic-dropdown");
    if (!link || !source) return;

    item.addEventListener("mouseenter", function () {
      if (isMobile()) return;
      cancelClose();
      openDropdown(item);
    });

    item.addEventListener("mouseleave", function () {
      if (isMobile()) return;
      scheduleClose();
    });

    link.addEventListener("click", function (event) {
      if (!isMobile()) return;

      event.preventDefault();
      event.stopPropagation();

      var pop = document.getElementById("tmgMobileDD");
      var sameItemOpen = pop && pop.classList.contains("is-open") && pop.classList.contains("is-ic-dropdown") && activeItem === item;

      if (sameItemOpen) closeSharedMobileDropdown();
      else openSharedMobileDropdown(item);
    });
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest(".ic-click-trigger");

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();

      var group = trigger.closest(".ic-click-group");
      if (group) {
        var parentMenu = group.parentElement;
        var willOpen = !group.classList.contains("is-open");

        if (parentMenu) {
          Array.prototype.forEach.call(parentMenu.children, function (sibling) {
            if (sibling !== group && sibling.classList && sibling.classList.contains("ic-click-group")) {
              sibling.classList.remove("is-open");
              sibling.querySelectorAll(".ic-click-group.is-open").forEach(function (nestedGroup) {
                nestedGroup.classList.remove("is-open");
              });
            }
          });
        }

        group.classList.toggle("is-open", willOpen);
      }
      return;
    }

    var insideDropdown = event.target.closest(".ic-floating-dropdown, #tmgMobileDD");
    var insideItem = event.target.closest(".ic-nav-item");

    if (!insideDropdown && !insideItem) {
      closeDropdown();
      closeSharedMobileDropdown();
    }
  });

  var floatingDropdown = getDropdown();

  floatingDropdown.addEventListener("mouseenter", cancelClose);
  floatingDropdown.addEventListener("mouseleave", function () {
    if (!isMobile()) scheduleClose();
  });

  window.addEventListener("scroll", closeDropdown, { passive: true });
  window.addEventListener("resize", closeDropdown, { passive: true });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDropdown();
  });
});

onStaticHeaderReady(function () {
  var stickyEnabled = staticHeaderStickyEnabled;
  if (!stickyEnabled) return;

  var desktopMini = document.querySelector("[data-tmg-sticky-mini]");
  var mobileMini = document.querySelector("[data-tmg-sticky-mobile]");

  if (desktopMini && desktopMini.parentElement !== document.body) document.body.appendChild(desktopMini);
  if (mobileMini && mobileMini.parentElement !== document.body) document.body.appendChild(mobileMini);

  function setHeights() {
    if (desktopMini) document.documentElement.style.setProperty("--tmg-sticky-h", (desktopMini.offsetHeight || 72) + "px");
    if (mobileMini) document.documentElement.style.setProperty("--tmg-mobile-sticky-h", (mobileMini.offsetHeight || 90) + "px");
  }

  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;

    if (desktopMini) document.body.classList.toggle("tmg-sticky-on", y > 150);
    if (mobileMini) document.body.classList.toggle("tmg-mobile-sticky-on", y > 150);
  }

  setHeights();
  onScroll();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () {
    setHeights();
    onScroll();
  }, { passive: true });
});

onStaticHeaderReady(function () {
  function bindScrollButtons(viewportId, selector) {
    var viewport = document.getElementById(viewportId);
    if (!viewport) return;

    document.querySelectorAll(selector).forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var dir = button.getAttribute(selector.includes("sticky") ? "data-tmg-sticky-scroll" : "data-nav-scroll") || button.getAttribute("data-mobile-sticky-scroll");
        var amount = Math.max(220, Math.floor(viewport.clientWidth * .65));

        viewport.scrollBy({
          left: dir === "left" ? -amount : amount,
          behavior: "smooth"
        });
      });
    });
  }

  bindScrollButtons("tmgNavViewport", "[data-nav-scroll]");
  bindScrollButtons("tmgStickyNavViewport", "[data-tmg-sticky-scroll]");
  bindScrollButtons("tmgMobileStickyNavViewport", "[data-mobile-sticky-scroll]");
});

onStaticHeaderReady(function () {
  var menu = document.querySelector(".fs-mobile-menu");
  if (!menu) return;

  var openButtons = [
    ...document.querySelectorAll("[fs-mobile-menu-toggle]"),
    ...document.querySelectorAll("[data-mobile-menu-open]"),
    document.getElementById("tmg-mobile-hamburger"),
    document.getElementById("fs-mobile-menu-toggle")
  ].filter(Boolean);

  var closeButtons = Array.from(menu.querySelectorAll("[data-fs-mobile-close]"));
  var backdrop = menu.querySelector(".fs-mobile-menu__backdrop");

  function openMenu(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    menu.classList.add("fs-mobile-menu--open");
    document.body.classList.add("fs-mobile-menu-open");
  }

  function closeMenu(event) {
    if (event) event.preventDefault();

    menu.classList.remove("fs-mobile-menu--open");
    document.body.classList.remove("fs-mobile-menu-open");
  }

  function toggleMenu(event) {
    if (menu.classList.contains("fs-mobile-menu--open")) closeMenu(event);
    else openMenu(event);
  }

  openButtons.forEach(function (button) {
    button.addEventListener("click", toggleMenu);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener("click", closeMenu);
  });

  if (backdrop) backdrop.addEventListener("click", closeMenu);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenu(event);
  });
});

onStaticHeaderReady(function () {
  var params = new URLSearchParams(window.location.search);
  var strength = params.get("strength");
  var targetValue = "";

  if (strength === "medium") targetValue = "X5";
  else if (strength === "high") targetValue = "X6";
  else if (strength === "ultra") targetValue = "X7";

  if (!targetValue) return;

  var input = document.querySelector('input[name="tmg_frame_series"][value="' + targetValue + '"]');
  if (!input) return;

  setTimeout(function () {
    input.checked = true;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    input.click();
  }, 300);
});

onStaticHeaderReady(function () {
  const mq = window.matchMedia("(max-width: 990px)");
  const pop = document.getElementById("tmgMobileDD");
  if (!pop) return;

  let activeButton = null;

  function closeMobileDD() {
    activeButton = null;
    pop.classList.remove("is-open", "is-greenhouses-dropdown", "is-ic-dropdown");
    pop.setAttribute("aria-hidden", "true");
    pop.innerHTML = "";
    document.body.classList.remove("tmg-mobile-active-dropdown--ic", "tmg-mobile-active-dropdown--tmg", "tmg-mobile-greenhouses-open");
  }

  function openMobileDD(item) {
    const button = item.querySelector("[data-dd-toggle]");
    const panel = item.querySelector("[data-dd-panel]");
    if (!button || !panel) return;

    let html = "";

    if (item.classList.contains("tmg-nav-item--greenhouses")) {
      html = panel.innerHTML;
    } else {
      const links = panel.querySelectorAll("a");
      if (!links.length) return;

      links.forEach(function (link) {
        const href = link.getAttribute("href") || "#";
        const text = (link.textContent || "").trim();

        if (text) {
          html += '<a href="' + href + '">' +
            text.replace(/</g, "&lt;").replace(/>/g, "&gt;") +
          "</a>";
        }
      });
    }

    pop.innerHTML = html;

    pop.style.left = "0px";
    pop.style.top = "0px";
    pop.classList.remove("is-ic-dropdown");
    pop.classList.add("is-open");
    pop.classList.toggle("is-greenhouses-dropdown", item.classList.contains("tmg-nav-item--greenhouses"));
    document.body.classList.remove("tmg-mobile-active-dropdown--ic");
    document.body.classList.add("tmg-mobile-active-dropdown--tmg");
    document.body.classList.toggle("tmg-mobile-greenhouses-open", item.classList.contains("tmg-nav-item--greenhouses"));
    pop.setAttribute("aria-hidden", "false");

    const rect = button.getBoundingClientRect();
    const padding = 10;
    const gap = -6;
    const width = pop.offsetWidth || 240;
    const height = pop.offsetHeight || 200;

    let left = rect.left;
    let top = rect.bottom + gap;

    if (left < padding) left = padding;
    if (left + width > window.innerWidth - padding) {
      left = window.innerWidth - width - padding;
    }

    if (top + height > window.innerHeight - padding) {
      top = rect.top - height - gap;
    }

    if (top < padding) top = padding;

    pop.style.left = Math.round(left) + "px";
    pop.style.top = Math.round(top) + "px";

    activeButton = button;
  }

  document.querySelectorAll(".tmg-nav-item--dropdown[data-dd]").forEach(function (item) {
    const button = item.querySelector("[data-dd-toggle]");
    if (!button) return;

    button.addEventListener("click", function (event) {
      if (!mq.matches) return;

      event.preventDefault();
      event.stopPropagation();

      const sameButtonOpen = pop.classList.contains("is-open") && activeButton === button;

      closeMobileDD();

      if (!sameButtonOpen) {
        openMobileDD(item);
      }
    });
  });

  pop.addEventListener("click", function (event) {
    const trigger = event.target.closest(".ic-click-trigger");
    if (trigger && pop.classList.contains("is-greenhouses-dropdown")) {
      const group = trigger.closest(".ic-click-group");
      if (group) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        Array.prototype.forEach.call(group.parentElement.children, function (sibling) {
          if (sibling !== group && sibling.classList && sibling.classList.contains("ic-click-group")) {
            sibling.classList.remove("is-open");
          }
        });

        group.classList.toggle("is-open");
        return;
      }
    }

    event.stopPropagation();
  }, true);

  document.addEventListener("click", function () {
    if (mq.matches) closeMobileDD();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMobileDD();
  });

  window.addEventListener("scroll", closeMobileDD, { passive: true });
  window.addEventListener("resize", closeMobileDD, { passive: true });
});

onStaticHeaderReady(function () {
  const viewport = document.getElementById("tmgNavViewport");
  if (!viewport) return;

  const leftArrow = document.querySelector('.tmg-nav-arrow[data-nav-scroll="left"]');
  const rightArrow = document.querySelector('.tmg-nav-arrow[data-nav-scroll="right"]');

  if (!leftArrow || !rightArrow) return;

  function canScrollLeft() {
    return viewport.scrollLeft > 2;
  }

  function canScrollRight() {
    return viewport.scrollLeft + viewport.clientWidth < viewport.scrollWidth - 2;
  }

  function updateArrows() {
    leftArrow.classList.toggle("is-disabled", !canScrollLeft());
    rightArrow.classList.toggle("is-disabled", !canScrollRight());

    leftArrow.classList.toggle("is-active", canScrollLeft());
    rightArrow.classList.toggle("is-active", canScrollRight());
  }

  function scrollNav(direction) {
    const amount = Math.max(260, Math.floor(viewport.clientWidth * 0.65));

    viewport.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth"
    });

    window.setTimeout(updateArrows, 300);
  }

  leftArrow.innerHTML = "‹";
  rightArrow.innerHTML = "›";

  leftArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (canScrollLeft()) scrollNav("left");
  });

  rightArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (canScrollRight()) scrollNav("right");
  });

  viewport.addEventListener("scroll", updateArrows, { passive: true });
  window.addEventListener("resize", updateArrows, { passive: true });
  window.addEventListener("load", updateArrows, { passive: true });

  updateArrows();
  requestAnimationFrame(updateArrows);
  setTimeout(updateArrows, 500);
});

onStaticHeaderReady(function () {
  var stickyCat = document.querySelector(".tmg-sticky-categories");
  if (!stickyCat) return;

  var trigger = stickyCat.querySelector(":scope > a");
  var mega = stickyCat.querySelector(".mega-menu");

  if (!trigger || !mega) return;

  trigger.addEventListener("click", function (event) {
    if (!window.matchMedia("(min-width: 991px)").matches) return;

    event.preventDefault();
    event.stopPropagation();

    stickyCat.classList.toggle("is-open");
  });

  document.addEventListener("click", function (event) {
    if (!stickyCat.contains(event.target)) {
      stickyCat.classList.remove("is-open");
    }
  });

  window.addEventListener("scroll", function () {
    stickyCat.classList.remove("is-open");
  }, { passive: true });
});

onStaticHeaderReady(function () {
  const viewport = document.getElementById("tmgStickyNavViewport");
  if (!viewport) return;

  const leftArrow = document.querySelector('[data-tmg-sticky-scroll="left"]');
  const rightArrow = document.querySelector('[data-tmg-sticky-scroll="right"]');

  if (!leftArrow || !rightArrow) return;

  function canScrollLeft() {
    return viewport.scrollLeft > 2;
  }

  function canScrollRight() {
    return viewport.scrollLeft + viewport.clientWidth < viewport.scrollWidth - 2;
  }

  function updateArrows() {
    leftArrow.classList.toggle("is-disabled", !canScrollLeft());
    rightArrow.classList.toggle("is-disabled", !canScrollRight());

    leftArrow.classList.toggle("is-active", canScrollLeft());
    rightArrow.classList.toggle("is-active", canScrollRight());
  }

  function scrollStickyNav(direction) {
    const amount = Math.max(240, Math.floor(viewport.clientWidth * 0.65));

    viewport.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth"
    });

    window.setTimeout(updateArrows, 300);
  }

  leftArrow.innerHTML = "‹";
  rightArrow.innerHTML = "›";

  leftArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (canScrollLeft()) {
      scrollStickyNav("left");
    }
  });

  rightArrow.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (canScrollRight()) {
      scrollStickyNav("right");
    }
  });

  viewport.addEventListener("scroll", updateArrows, { passive: true });
  window.addEventListener("resize", updateArrows, { passive: true });
  window.addEventListener("load", updateArrows, { passive: true });

  updateArrows();
  requestAnimationFrame(updateArrows);
  setTimeout(updateArrows, 500);
});

onStaticHeaderReady(function () {
  function closeAllHeaderDropdowns() {
    var floatDropdown = document.getElementById("tmgFloatDropdown");
    if (floatDropdown) {
      floatDropdown.classList.remove("is-open", "is-greenhouses-dropdown");
      floatDropdown.setAttribute("aria-hidden", "true");
      floatDropdown.innerHTML = "";
      floatDropdown.style.display = "";
    }

    var mobileDropdown = document.getElementById("tmgMobileDD");
    if (mobileDropdown) {
      mobileDropdown.classList.remove("is-open", "is-greenhouses-dropdown");
      mobileDropdown.setAttribute("aria-hidden", "true");
      mobileDropdown.innerHTML = "";
      mobileDropdown.style.display = "";
    }

    document.querySelectorAll(".ic-floating-dropdown").forEach(function (dropdown) {
      dropdown.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
      dropdown.innerHTML = "";
      dropdown.style.display = "";
    });

    document.querySelectorAll(".ic-nav-item").forEach(function (item) {
      item.classList.remove("is-open", "active");
    });

    document.querySelectorAll(".ic-click-group.is-open").forEach(function (group) {
      group.classList.remove("is-open");
    });

    document.querySelectorAll(".tmg-nav-item--dropdown, .tmg-nav-item--float").forEach(function (item) {
      item.classList.remove("is-open", "active");
    });

    document.querySelectorAll(".tmg-sticky-categories.is-open").forEach(function (item) {
      item.classList.remove("is-open");
    });

    document.querySelectorAll(".tmg-country.is-open, .m-country.is-open").forEach(function (country) {
      country.classList.remove("is-open");

      var trigger = country.querySelector("[aria-expanded]");
      var dropdown = country.querySelector(".tmg-country__dropdown, .m-country__dropdown");

      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (dropdown) dropdown.hidden = true;
    });
  }

  window.addEventListener("scroll", closeAllHeaderDropdowns, { passive: true });

  document.querySelectorAll(
    ".tmg-nav-scroll__viewport, .tmg-sticky-nav__viewport"
  ).forEach(function (viewport) {
    viewport.addEventListener("scroll", closeAllHeaderDropdowns, { passive: true });
    viewport.addEventListener("touchmove", closeAllHeaderDropdowns, { passive: true });
    viewport.addEventListener("wheel", closeAllHeaderDropdowns, { passive: true });
  });
});

  if (staticHeaderScript) {
    staticHeaderScript.__tmgRunStaticHeaderReadyFallback = function () {
      if (staticHeaderReadyDispatched) return;
      staticHeaderReadyDispatched = true;

      staticHeaderReadyCallbacks.forEach(function (callback) {
        try {
          callback();
        } catch (error) {
          window.setTimeout(function () {
            throw error;
          }, 0);
        }
      });
    };
  }
})();
